module.exports = __webpack_public_path__ + "static/media/bg-Latop-STIP-blur.78968dc5.png";